import { Link, useLocation } from 'react-router-dom';

import { useTranslation } from 'react-i18next';
import { ChevronRightIcon } from 'lucide-react';

import { useNavigationItems } from '@/hooks/use-navigation-items';

import {
  SidebarGroup,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
  SidebarMenuSub,
  SidebarMenuSubButton,
  SidebarMenuSubItem,
} from '../ui/sidebar';
import { Collapsible, CollapsibleContent, CollapsibleTrigger } from '../ui/collapsible';

type NavigationItemsProps = {
  onClick?: () => void;
};

export function NavigationItems({ onClick }: NavigationItemsProps) {
  const { navItems } = useNavigationItems();
  const { t } = useTranslation();
  const { pathname } = useLocation();

  const isActive = (href: string | undefined) => {
    if (!href) return false;
    if (href === '/') return pathname === href;
    return pathname === href || pathname.startsWith(href);
  };

  return (
    <SidebarGroup>
      <SidebarMenu>
        {navItems.map((nav) => {
          if (nav.subItems) {
            return (
              <Collapsible
                key={nav.label_translation_key}
                asChild
                defaultOpen={false}
                className="group/collapsible"
              >
                <SidebarMenuItem>
                  <CollapsibleTrigger asChild>
                    <SidebarMenuButton isActive={isActive(nav.href)}>
                      <nav.icon className="text-secondary dark:text-primary !size-6" />
                      <span>{t(nav.label_translation_key)}</span>
                      <ChevronRightIcon className="ml-auto transition-transform duration-200 group-data-[state=open]/collapsible:rotate-90" />
                    </SidebarMenuButton>
                  </CollapsibleTrigger>
                  <CollapsibleContent>
                    <SidebarMenuSub>
                      {nav.subItems?.map((subItem) => (
                        <SidebarMenuSubItem key={subItem.label_translation_key}>
                          <SidebarMenuSubButton asChild isActive={isActive(subItem.href)}>
                            <Link onClick={onClick} to={subItem.href ?? '#'}>
                              <subItem.icon className="text-secondary dark:text-primary !size-6" />
                              <span>{t(subItem.label_translation_key)}</span>
                            </Link>
                          </SidebarMenuSubButton>
                        </SidebarMenuSubItem>
                      ))}
                    </SidebarMenuSub>
                  </CollapsibleContent>
                </SidebarMenuItem>
              </Collapsible>
            );
          }
          return (
            <SidebarMenuItem key={nav.label_translation_key}>
              <SidebarMenuButton asChild isActive={isActive(nav.href)}>
                <Link onClick={onClick} to={nav.href ?? '#'}>
                  <nav.icon className="text-secondary dark:text-primary !size-6" />
                  <span>{t(nav.label_translation_key)}</span>
                </Link>
              </SidebarMenuButton>
            </SidebarMenuItem>
          );
        })}
      </SidebarMenu>
    </SidebarGroup>
  );
}
